import { useEffect, useState } from "react";
import { getTestimonials } from "../lib/api";

export default function TestimonialMarquee() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    getTestimonials().then(d => setItems(d.items || [])).catch(() => {});
  }, []);

  if (!items.length) return null;
  const doubled = [...items, ...items];

  return (
    <section data-testid="testimonials-marquee" className="py-24 md:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 mb-12">
        <div className="eyebrow mb-3">Whispers</div>
        <h2 className="font-serif text-3xl md:text-5xl text-cream max-w-2xl leading-tight">
          What guests of the salon have said.
        </h2>
      </div>

      <div className="no-scrollbar overflow-hidden">
        <div className="marquee-track gap-12 px-6 md:px-10">
          {doubled.map((t, i) => (
            <figure
              key={i}
              className="min-w-[320px] md:min-w-[480px] max-w-[520px] px-6"
              data-testid={`testimonial-${i}`}
            >
              <blockquote className="font-serif italic text-xl md:text-2xl text-cream/85 leading-snug">
                <span className="text-gold text-3xl mr-1 align-top leading-none">“</span>
                {t.quote}
                <span className="text-gold text-3xl ml-1 align-top leading-none">”</span>
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 text-xs uppercase tracking-[0.2em] text-cream/50">
                <span className="text-gold">{t.initials}</span>
                <span>·</span>
                <span>{t.session_type}</span>
                <span>·</span>
                <span>{t.date}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
